<template>
  <div v-if="content" v-editable="content" class="parc">
    <div class="content-wrapper">
      <p v-html="content.title" class="title"></p>
      <img :src="content.img">
      <a :href="content.link.cached_url" class>{{content.labelLink}}</a>
      <grid :content="content.item[0]"></grid>
      <div class="text">
        <vue-markdown>{{content.text}}</vue-markdown>
        <custom-btn class="btn">{{content.button[0].label}}</custom-btn>
      </div>
    </div>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";

export default {
  components: {
    VueMarkdown
  },
  props: {
    content: null
  }
};
</script>

<style lang="scss">
</style>
